import { Serializable } from '../../common/types'

export class CenterTimeAndDutyReportDates extends Serializable<CenterTimeAndDutyReportDates> {
  center_id: number | null = null
  center_name: number | null = null
  dates: string[] | null = null

  constructor(details: Partial<CenterTimeAndDutyReportDates>) {
    super()
    this.checkAndDeserialize(details)
  }

  deserialize(details: Partial<CenterTimeAndDutyReportDates>): void {
    this.center_id = details.center_id
    this.center_name = details.center_name
    this.dates = (details.dates ?? []).reverse()
  }
}
